<template>
  <div class="background-03">

    <v-layout row wrap>
      <v-flex xs12 sm2 md2 class="hidden-xs-only">
        <image-app class="animated fadeInLeft" :imaSize="300" imaSrc="design/banco1-1-3" imaAlt=""></image-app>
      </v-flex>
      <v-flex xs12 sm9 class="animated fadeInUp dura_1">
        <ui-title-one titleAccess="¿Qué es un presupuesto?" titleLevel="h1">
          <template slot="partOne">¿Qué es un <br></template>
          <!-- <template slot="partTwo"></template> -->
          <template slot="partThree"> presupuesto?</template>
        </ui-title-one>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 class="text-xs-center">
        <ui-simple-lsc :vidTittle="'¿Qué es un presupuesto?'" videoEmbed="ADMINISTRACIONDINERO17QueEsPresupuesto (48).mp4"></ui-simple-lsc>
      </v-flex>
      <v-flex xs12 md6 class="animated fadeInUp dura_2 aligner">
        <p class="text-box adorn-bottom">
          Un presupuesto es una herramienta que ayuda a organizar el dinero para ser utilizado de una forma óptima. <br><br> Se convierte en un
          <strong>plan de acción</strong> dirigido a cumplir una meta prevista, expresada en valores y términos financieros. <br><br> Se construye registrando los
          <strong>ingresos</strong> y los
          <strong>gastos</strong> de un periodo de tiempo determinado.
          <audio-player ref="audioPlayer" :autoplay="true" :audios="[
            'Administracion5.mp3'
            ]"></audio-player>
        </p>
      </v-flex>
      <v-flex xs12 sm5 md5 text-xs-center class="aligner animated fadeIn dura_2">
        <image-app :imaSize="230" imaSrc="contenido/personaje_1" imaAlt="Mujer explicando el concepto"></image-app>
      </v-flex>
    </v-layout>

  </div>
</template>

<script>
export default {
  props: {
    modName: {
      type: String,
      required: false
    }
  },
  data() {
    return {};
  },
  mounted() {
    this.$store.commit("nextShow", true);
  }
};
</script>


// WEBPACK FOOTER //
// davivienda-17.vue?bbcb6ae4